import CommonDialog from "components/dialog/CommonDialog/CommonDialog";
import { useDialogContext } from "components/dialog/controller/DialogProvider";
import { useEffect } from "react";
import useDialogStore, { ConfirmDialogForm } from "stores/useDialogStore";

export const useConfirmDialog = () => {
  const { openDialog, closeDialog } = useDialogContext();
  const { setDialogForm } = useDialogStore();

  const openConfirmDialog = (form: ConfirmDialogForm) => {
    setDialogForm(form);
    openDialog(CommonDialog);
  };

  useEffect(() => {
    return () => {
      closeDialog();
      setDialogForm(null);
    };
  }, []);

  return { openConfirmDialog };
};
